export default {
  methods: {
    dialogChanged(dialogType, value) {
      if (value) {
        this.gtmPush({ event: 'notification_show', 'notification.type': dialogType });
      } else {
        this.gtmPush({ event: 'notification_close', 'notification.type': dialogType });
      }
    }
  }
};
